"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BREAKPOINTS = void 0;
// TODO: Get from Tokens pkg
exports.BREAKPOINTS = ['def', 'sm', 'md', 'lg', 'xl'];
//# sourceMappingURL=constants.js.map